import { useParams } from "react-router-dom";

/** Typed route params for matched leaf routes where params are expected to be present. */
export function useRouteParams<T extends Record<string, string | undefined>>(): T {
  return useParams() as T;
}
